import type { InsightPost } from "./types";

export const INSIGHT_CATEGORY_LABEL: Record<InsightPost["category"], string> = {
  notary: "Notary Public",
  translation: "งานแปลรับรอง",
  legalization: "MFA / กงสุล",
  marriage: "จดทะเบียนสมรส",
  visa: "Visa & Immigration",
  guide: "คู่มือทั่วไป",
};
